<div *ngIf="jobId$ | async as jobId"
     class="col-md-12" style="font-family: 'Play', sans-serif; padding: 0;">
  <missed-recall-report-filter-component [hidden]="selectedTab === 'messagingDetails'"
                                         [fromDate]="fromDate$ | async"
                                         [disabled]="loading$ | async"
                                         (dateChangeEmitter)="onDateChange($event)"></missed-recall-report-filter-component>
  <div *ngIf="reports$ | async as report">
    <tabset>
      <tab heading="In Progress" id="inProgress" (selectTab)="onTabSelect($event)">
        <br/>
        <missed-recall-report-table tableType="inProgress"
                                    [report]="report.inProgress"></missed-recall-report-table>
      </tab>
      <tab heading="Successful" id="successful" (selectTab)="onTabSelect($event)">
        <br/>
        <missed-recall-report-table tableType="successful"
                                    [report]="report.successful"></missed-recall-report-table>
      </tab>
      <tab heading="Unsuccessful" id="unsuccessful" (selectTab)="onTabSelect($event)">
        <br/>
        <missed-recall-report-table tableType="unsuccessful"
                                    [report]="report.unsuccessful"></missed-recall-report-table>
      </tab>
      <tab heading="Messaging Details" id="messagingDetails" (selectTab)="onTabSelect($event)">
        <br/>

        <ng1-message-details-report [jobId]="jobId">
        </ng1-message-details-report>
        <!-- <messaging-details-report job-id="job"></messaging-details-report> -->

      </tab>

    </tabset>


    <img *ngIf="loading$ | async" style="width: 24px; margin: 4px;" src="/img/loading.gif"/>

  </div>
</div>
